import createStreamingWorkerFunction from "../../../createStreamingWorkerFunction.js";
import createWorkerInBrowser from "../../../environment/createWorkerInBrowser.js";
export default function createStreamingWorkerFunctionInBrowser(fnOrAlias) {
    return createStreamingWorkerFunction(createWorkerInBrowser, fnOrAlias);
}
